const isString = (value) => {
  return (
    !(value === undefined) && !(value === null) && typeof value === "string"
  );
};

const isStringOrNumber = (value) => {
  return (
    !(value === undefined) &&
    !(value === null) &&
    (typeof value === "string" || typeof value === "number")
  );
};

export const isValidEmail = (value) => {
  if (!isString(value)) return false;
  return String(value)
    .trim()
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    ? true
    : false;
};

export const isNumberInRange = (min, max) => {
  return (value) => {
    if (!isStringOrNumber(value)) return false;
    const v = Number(value);
    if (isNaN(v)) return [false, "Vain numeroita!"];
    return [min <= value && value <= max, `Tulee olla välillä ${min} - ${max}`];
  };
};

export const passthru = (value) => true;
export const mustBeTrue = (value) => value === true;

export const isValidName = (value) => {
  if (!isString(value)) return false;
  return String(value).trim().length > 5;
};

export const isValidShortName = (value) => {
  if (!isString(value)) return false;
  return String(value).trim().length >= 2;
};

export const isValidContents = isValidName;
export const isValidAddress = isValidName;

export const isValidPhone = (value) => {
  if (!isString(value)) return false;
  return String(value)
    .trim()
    .toLowerCase()
    .replaceAll(" ", "")
    .match(/^[+]?([0-9]){5,}$/)
    ? true
    : false;
};

export const isValidPostalCode = (value) => {
  if (!isString(value)) return false;
  return String(value)
    .trim()
    .toLowerCase()
    .match(/^([0-9]){5}(\s[\sa-zåäö]*)?$/)
    ? true
    : false;
};

export const hasAtLeastOneDigit = (value) => {
  if (!isString(value)) return false;
  return String(value).match(/[0-9]/) ? true : false;
};
export const hasAtLeastOneLetter = (value) => {
  if (!isString(value)) return false;
  return String(value)
    .toLowerCase()
    .match(/[a-zåäö]/)
    ? true
    : false;
};

export const isValidPassword = (value) => {
  if (!isString(value)) return false;
  if (String(value).trim().length < 8)
    return [false, "Salasana on liian lyhyt"];
  if (!hasAtLeastOneLetter(value))
    return [false, "Salasanassa tulee olla vähintään yksi kirjain"];
  if (!hasAtLeastOneDigit(value))
    return [false, "Salasanassa tulee olla vähintään yksi numero"];
  return true;
};

export const isValidBID = (value) => {
  if (!isString(value)) return false;
  const normalized = String(value).trim().toLowerCase().replaceAll(" ", "");
  const formValid = normalized.match(/^([0-9]){7,}-[0-9]$/);
  if (!formValid) return [false, "Y-tunnuksen muoto on virheellinen"];
  const weights = [7, 9, 10, 5, 8, 4, 2];
  const baseCode = normalized.substring(0, 7);
  const checkDigit = Number(normalized[8]);
  const calculatedSum = [...baseCode].reduce(
    (base, digit, index) => base + Number(digit) * weights[index],
    0
  );
  const remainder = calculatedSum % 11;
  const calculatedDigit = remainder === 0 ? 0 : 11 - remainder;
  if (checkDigit !== calculatedDigit)
    return [false, "Y-tunnus on virheellinen"];
  return true;
};

export const passwordsMatch = (value, values) => {
  if (values["iPassword"] !== values["iPassword2"])
    return [false, "Salasanat eivät täsmää!"];
  return isValidPassword(value);
};
